import clsx from "clsx";
import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import styles from "./Banner.scss";

const propTypes = {
  /**
   * Message for banner.
   */
  message: PropTypes.node,
  /**
   * Button text for banner.
   */
  buttonText: PropTypes.node,
  /**
   * Button callback for banner.
   */
  onPress: PropTypes.func.isRequired,
  /**
   * show screen in read only mode
   */
  readOnly: PropTypes.bool,
};

const defaultProps = {
  message: "",
  buttonText: "",
  readOnly: false,
};

function Banner(props) {
  const { buttonText, message, onPress, readOnly } = props;
  return (
    <div className={clsx(styles.base)}>
      <div>
        <i className={clsx("fas fa-exclamation-triangle", styles.icon)} />
        <span className={clsx(styles.msg_text)}>{message}</span>
      </div>
      <Button
        disabled={readOnly}
        onClick={() => onPress()}
        className={clsx(styles.button_view)}
      >
        {buttonText}
      </Button>
    </div>
  );
}

Banner.propTypes = propTypes;
Banner.defaultProps = defaultProps;

export default Banner;
